const de_DE = {
  "colorpicker.opacity-input": "Opazität",
  "datepicker.clear-date": "Datum löschen",
  "datepicker.next-month": "Nächsten Monat",
  "datepicker.open-calendar": "Kalender öffnen",
  "datepicker.previous-month": "Vorheriger Monat",
  "input.clear": "Eingabe löschen",
  "input.hide-password": "Passwort verbergen",
  "input.show-password": "Passwort anzeigen",
  "modal.close": "Schließen",
  "multiselectchips.add-value": "Füge ‘{value}’ hinzu",
  "multiselectchips.remove-all": "Alle entfernen",
  "pagination.next-page": "Nächste Seite",
  "pagination.previous-page": "Vorherige Seite"
};
export {
  de_DE as default
};
//# sourceMappingURL=de_DE.json.js.map
